import Model from '@/Models/Contracts/Model';
export default class Review extends Model {
    resource() {
        return 'reviews';
    }
}
